import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function useRouteToast() {
  const location = useLocation();
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (location.state?.toast) {
      setToast(location.state.toast);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.pathname, location.state, navigate]);

  return {
    clearToast: () => setToast(null),
    toast,
  };
}
